import React from 'react';

interface ExternalLinkIconProps {
  size?: number;
  color?: string;
  className?: string;
  'aria-hidden'?: boolean;
}

/**
 * ExternalLinkIcon Component
 * @description An external link icon indicating links that open in a new tab
 */
export const ExternalLinkIcon: React.FC<ExternalLinkIconProps> = ({ 
  size = 16, 
  color = 'currentColor',
  className,
  'aria-hidden': ariaHidden = true,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden={ariaHidden}
    >
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
      <polyline points="15 3 21 3 21 9" />
      <line x1="10" y1="14" x2="21" y2="3" />
    </svg>
  );
};

export default ExternalLinkIcon;

